"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractThemeId = exports.extractTreeId = exports.isLawTheme = void 0;
var firebaseRecords_1 = require("@livv/models/firebaseRecords");
var isLawTheme = function (value) {
    return Object.values(firebaseRecords_1.LawThemes).includes(value);
};
exports.isLawTheme = isLawTheme;
var extractTreeId = function (path) {
    var decodedPath = decodeURIComponent(path);
    var _a = __read(decodedPath.split('/'), 2), theme = _a[0], treeId = _a[1];
    return theme && treeId && (0, exports.isLawTheme)(theme) ? treeId : null;
};
exports.extractTreeId = extractTreeId;
var extractThemeId = function (path) {
    var decodedPath = decodeURIComponent(path);
    var _a = __read(decodedPath.split('/'), 1), theme = _a[0];
    return theme && (0, exports.isLawTheme)(theme) ? theme : null;
};
exports.extractThemeId = extractThemeId;
//# sourceMappingURL=index.js.map